import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, Injectable, Injector, NgModule} from '@angular/core';
import * as Rollbar from 'rollbar';
import { environment } from '../environments/environment';
import { HttpClientModule  } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Select2Module } from 'ng2-select2';
import { MatDialogModule, MatTooltipModule, MatButtonModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomFormsModule } from 'ng2-validation';
import { RestangularModule } from 'ngx-restangular';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { PapaParseModule } from 'ngx-papaparse';
import { TextMaskModule } from 'angular2-text-mask';

import { routing } from './app-routes';
import { RestAngularConfig } from './service/restAngular/rest-angular-config';
import { AuthGuard } from './service/auth-guard.service';
import { DataToSaveService } from './service/data-to-save.service';
import { SavedFilesApi } from './components/saved-files/saved-files.api';
import { RememberMeService } from './service/remember-me.service';
import { ImportService } from './service/import.service';
import { TrackingService } from './service/tracking.service';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { OringRecommendationComponent } from './components/oring-recommendation/oring-recommendation.component';
import { GrooveRecommendationComponent } from './components/groove-recommendation/groove-recommendation.component';
import { DesignValidationComponent } from './components/design-validation/design-validation.component';
import { InputArrowComponent } from './components/input-arrow/input-arrow.component';
import { RequestQuoteComponent } from './components/shared/request-quote/request-quote.component';
import { LoginSignupComponent } from './components/login-signup/login-signup.component';
import { ForgotPasswordComponent } from './components/login-signup/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/login-signup/reset-password/reset-password.component';
import { FileNameComponent } from './components/header/file-name/file-name.component';
import { SavedFilesComponent } from './components/saved-files/saved-files.component';
import { SuccessSignupComponent } from './components/login-signup/success-signup/success-signup.component';
import { SuccessResetComponent } from './components/login-signup/success-reset/success-reset.component';
import { AccountActivationComponent } from './components/login-signup/account-activation/account-activation.component';
import { NotifyComponent } from './components/saved-files/notify/notify.component';
import { SuccessComponent } from './components/shared/request-quote/success/success.component';
import { FileDeleteComponent } from './components/saved-files/file-delete/file-delete.component';
import { NoConnectionComponent } from './components/no-connection/no-connection.component';

import { ErrorTooltipDirective } from './components/shared/error-tooltip/error-tooltip.directive';
import { DetectCapslockDirective } from './components/shared/detect-capslock.directive/detect-capslock.directive';
import { TrimDirective } from './components/shared/trim.directive/trim.directive';
import { SelectTextDirective } from './components/shared/select-text.directive/select-text.directive';
import { RotateTooltipDirective } from './components/shared/rotate-tooltip/rotate-tooltip.directive';
import { InfoComponent } from './components/info/info.component';
import {ListOfPopularDomains} from "./components/login-signup/list-of-popular-domains";
import { RestrictedEmailComponent } from './components/login-signup/restricted-email/restricted-email.component';

const rollbarConfig = {
  accessToken: '7ab59222674a4d768dd9d8b552aef29a',
  captureUncaught: true,
  captureUnhandledRejections: true,
};

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) { }
  handleError(err: any) {
    const rollbar = this.injector.get(Rollbar);
    if (environment.production) {
      rollbar.error(err.originalError || err);
    }
    console.error(err);
  }
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    OringRecommendationComponent,
    GrooveRecommendationComponent,
    InputArrowComponent,
    DesignValidationComponent,
    RequestQuoteComponent,
    ErrorTooltipDirective,
    HomeComponent,
    LoginSignupComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    FileNameComponent,
    SavedFilesComponent,
    SuccessSignupComponent,
    SuccessResetComponent,
    AccountActivationComponent,
    NotifyComponent,
    SuccessComponent,
    FileDeleteComponent,
    TrimDirective,
    DetectCapslockDirective,
    NoConnectionComponent,
    SelectTextDirective,
    RotateTooltipDirective,
    InfoComponent,
    RestrictedEmailComponent,
  ],
  exports: [
    RequestQuoteComponent,
    MatTooltipModule
  ],
  imports: [
    BrowserModule,
    HttpClientModule ,
    FormsModule,
    Select2Module,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    routing,
    CustomFormsModule,
    RestangularModule.forRoot([], RestAngularConfig.RestangularConfigFactory),
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    PapaParseModule,
    TextMaskModule

  ],
  providers: [
    ListOfPopularDomains,
    // { provide: ErrorHandler, useClass: RollbarErrorHandler },
    { provide: Rollbar,
      useFactory () {
        return new Rollbar(rollbarConfig);
      }
    },
    AuthGuard, DataToSaveService, SavedFilesApi, RememberMeService, ImportService, TrackingService
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    RequestQuoteComponent,
    ForgotPasswordComponent,
    FileNameComponent,
    SuccessSignupComponent,
    SuccessResetComponent,
    SuccessComponent,
    FileDeleteComponent,
    RestrictedEmailComponent
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/app.module.ts